import { Injectable } from '@angular/core';
import { TrxService } from '~services/trx/trx.service';
import { createFeatureFlagClient, FeatureFlagUser, FeatureFlagClient } from '@zip/feature-flag-js';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagService {
  featureFlagClient: FeatureFlagClient;
  private _isShopCentralEnabled = false;

  constructor(private trxService: TrxService, private cookieService: CookieService) {}

  async init(user: FeatureFlagUser) {
    try {
      this.featureFlagClient = createFeatureFlagClient(this.trxService.analytics, {
        deploymentKey: environment.zipFeatureFlag.deploymentKey,
        environment: environment.zipFeatureFlag.env,
      });

      await this.featureFlagClient.start(user);
    } catch (error) {
      console.error('Failed to initialise feature flag', error);
    }
  }

  isFeatureEnabled(key: string) {
    try {
      const featureFlag = this.featureFlagClient.getFeatureFlag(key);
      return !!featureFlag;
    } catch (error) {
      console.error('Failed to retrieve feature flag', error);
      return false;
    }
  }

  get isShopCentralEnabled() {
    return this._isShopCentralEnabled;
  }

  initShopCentralFeature() {
    const isShopCentralSession = this.cookieService.get('loyalty-shop-central-giftcards');
    if (isShopCentralSession) {
      this._isShopCentralEnabled = isShopCentralSession === 'true';
    } else {
      this._isShopCentralEnabled = this.isFeatureEnabled('loyalty-shop-central-giftcards');
      this.cookieService.set(
        'loyalty-shop-central-giftcards',
        this._isShopCentralEnabled.toString(),
      );
    }
  }
}
